import React, { useEffect, useState } from 'react';
import { Container, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';

import { driverListState } from '../../atoms/DriverListState';
import DefaultDialog from '../../components/Dialog/Default';
import ListHeader from '../../components/ListHeader';
import Pagination from '../../components/Pagination';
import { listDrivers, resignContract } from '../../repositories/HttpRepository';
import Detail from './detail';
import SearchForm from './searchForm';
import useStyles from './styles';
import { toast } from 'react-toastify';

const fields = [
  { id: 'driver_id', numeric: false, disablePadding: true, label: 'Driver ID' },
  {
    id: 'driver_name',
    numeric: false,
    disablePadding: false,
    label: 'Driver Name',
    isDisableSort: true,
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: false,
    label: 'Email',
    isDisableSort: true,
  },
  { id: 'actions', numeric: false, isDisableSort: true },
];

const DriverList = () => {
  const [drivers, setDrivers] = useRecoilState(driverListState);
  const { items, page, size, desc, order_by, total, isListing, q } = drivers;

  const navigate = useNavigate();
  const { classes } = useStyles();
  let { id } = useParams();
  const [loadingResign, setLoadingResign] = useState(false);

  const getList = (params) => {
    let queryParams = { size, page, q, order_by, desc };
    if (params) queryParams = { ...queryParams, ...params };
    listDrivers(queryParams).then((resp) => {
      if (resp.ok) {
        const data = resp.data;
        setDrivers({
          ...drivers,
          items: data.drivers,
          page: data.page,
          size: data.size,
          total: data.count,
        });
      }
    });
  };

  useEffect(() => {
    getList();
  }, [q, order_by, desc, page]);

  const handleChangePage = (event, newPage) => {
    setDrivers({ ...drivers, page: newPage });
  };

  const handleRequestSort = (event, property) => {
    const isDesc = order_by === property && desc;
    setDrivers({
      ...drivers,
      desc: !isDesc,
      order_by: property,
    });
  };
  const handleAgreeResign = (driverId) => {
    setLoadingResign(true);

    resignContract({ driver_ids: [driverId] }).then((resp) => {
      setLoadingResign(false);
      if (resp.ok) {
        getList();
        toast.success('A request resign contract has been to send to this driver');
      } else {
        toast.error(resp?.data?.message || 'Server has some problems');
      }
    });
  };

  return (
    <Container maxWidth={false} className={classes.root}>
      <SearchForm initValue={q} placeholder="Search for id:driver ID, driver name, email" />
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <ListHeader fields={fields} desc={desc} orderBy={order_by} onRequestOrder={handleRequestSort} rowCount={total} />
            <TableBody>
              {items &&
                items.map((item, index) => {
                  const labelId = `dsp-table-item-${index}`;
                  const firstName = item.first_name ? item.first_name + ' ' : '';
                  const lastName = item.last_name ? item.last_name : '';
                  return (
                    <TableRow hover tabIndex={-1} key={item.id}>
                      <TableCell component="th" id={labelId} scope="row">
                        {item.id}
                      </TableCell>
                      <TableCell>{firstName + lastName}</TableCell>
                      <TableCell>{item.email}</TableCell>
                      <TableCell align={'right'}>
                        <DefaultDialog
                          btnString="Resign contract"
                          title="Do you want to force this driver to resign a contract?"
                          description=""
                          handleAgree={() => {
                            handleAgreeResign(item.id);
                          }}
                          disabled={false}
                          isLoading={loadingResign}
                          style={{
                            padding: '3px 10px',
                            marginLeft: '5px',
                            boxShadow: 'none',
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          {isListing && <LinearProgress />}
        </TableContainer>
        <Pagination total={total} size={size} onChange={handleChangePage} forceUpdatePage={page - 1} />
      </Paper>

      {id && <Detail></Detail>}
    </Container>
  );
};
export default React.memo(DriverList);
